export default __webpack_public_path__ + "static/media/logo.4a01764f.svg";